export function getLinkFromSentence(text: string) {
    return text.toLowerCase().split(' ').join('-');
}
